import patternize from '@sdk/helpers/formatters/patternize';
import invalidCPF, { CPF_FORMAT } from '@cordel/helpers/form/validators/cpf';
import invalidCNPJ, { CNPJ_FORMAT } from '@cordel/helpers/form/validators/cnpj';

import {
  SEARCH,
  SELLER_ID,
  STORE_ID,
  STATUS,
  BANK_CODE,
  SORT,
} from './fields';

export default function payload() {
  return {
    customer: {
      field: SEARCH,
      getter(value) {
        if (/\d/.test(value)) {
          if (!invalidCPF(value) && value.length < CPF_FORMAT.length) {
            return patternize(value, { format: CPF_FORMAT });
          }
          if (!invalidCNPJ(value) && value.length < CNPJ_FORMAT.length) {
            return patternize(value, { format: CNPJ_FORMAT });
          }
        }
        return value;
      },
    },
    seller_ids: [{
      field: SELLER_ID,
    }],
    header_store_id: {
      field: STORE_ID,
    },
    bank_codes: [{
      field: BANK_CODE,
    }],
    pre_approval_status: [{
      field: STATUS,
    }],
    sort: {
      field: SORT,
    },
  };
}
